import { tailwindMergeConfig } from "shared-web/lib/classNames"
import { extendTailwindMerge, ClassNameValue } from "tailwind-merge"

const baseTheme = tailwindMergeConfig.extend.theme
const baseGroups = tailwindMergeConfig.extend.classGroups

/* DO NOT EDIT THIS FILE */
/**
 * Note: These are all deprecated styles - we should migrate all of them to styles from base.css.
 * Once we do that, we can remove this file.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [...baseTheme.text, "xxs"],
      color: [
        ...baseTheme.color,
        "text-primary-light",
        "text-primary-dark",
        "text-tertiary-light",
        "text-tertiary-dark",
        "text-placeholder-light",
        "text-placeholder-dark",
        "text-error-light",
        "text-error-dark",
        "text-success-light",
        "text-success-dark",
        "text-info-light",
        "text-info-dark",
        "text-disable-light",
        "text-disable-dark",
        "surface-primary-light",
        "surface-primary-dark",
        "surface-accent-light",
        "surface-accent-dark",
        "surface-secondary-accent-light",
        "surface-secondary-accent-dark",
        "border-primary-light",
        "border-primary-dark",
        "border-accent-light",
        "border-accent-dark",
        "accent-primary-light",
        "accent-primary-dark",
        "accent-error-light",
        "accent-error-dark",
        "accent-negative-light",
        "accent-negative-dark",
        "accent-negative-secondary-light",
        "accent-negative-secondary-dark",
        "disable-light",
        "disable-dark",
      ],
      shadow: [...baseTheme.shadow, "light", "dark"],
      animate: baseTheme.animate,
      spacing: baseTheme.spacing,
    },
    classGroups: {
      "text-color": [
        ...baseGroups["text-color"],
        "text-primary",
        "text-primary-inverted",
        "text-accent-primary",
        "text-tertiary",
        "text-error",
        "text-info",
        "text-disable",
        "text-placeholder",
      ],
      "bg-color": [
        ...baseGroups["bg-color"],
        "surface-primary",
        "surface-primary-inverted",
        "surface-accent",
        "surface-secondary-accent",
      ],
      "border-color": [...baseGroups["border-color"]],
      "divide-color": baseGroups["divide-color"],
      stroke: baseGroups.stroke,
    },
  },
})

export function classNames(...classes: ClassNameValue[]): string {
  return twMerge(classes)
}
